export default function CategorySelect({ categories, selectedCategoryCode, onChange, disabled }) {
  return (
    <div className="supplier-category-control">
      <label htmlFor="supplierCategory">
        <strong>Supplier Category</strong>
      </label>
      <br />
      <select
        id="supplierCategory"
        value={selectedCategoryCode}
        onChange={(event) => onChange(event.target.value)}
        disabled={disabled}
      >
        <option value="">--- Select Category ---</option>
        {categories.map((category) => (
          <option key={category.Code} value={category.Code}>
            {category.Description}
          </option>
        ))}
      </select>
    </div>
  );
}
